import { createAsyncThunk } from "@reduxjs/toolkit";

import { EndPoints } from "../../api/endpoints";
import axiosClient, { isStaleAuthFailure } from "../../api/axiosClient";

/** Check if user exists */
export const getMe = createAsyncThunk(
  "user/me",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.me);
      const res = await axiosClient.get("notifications/maintenance");
      return { ...response.data, ...res.data };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
        // The token this call was signed with has already been replaced, so the
        // failure says nothing about the session we hold now — see the slice.
        stale: isStaleAuthFailure(error?.config),
      });
    }
  }
);
